export const MixpanelEvents = {
    TT_START_SESSION: "tt_start_session",
    STEP_ON_MAP_CLICK: "tt_step_on_map_click",
    TT_PIN_CLICKED: "tt_pin_clicked",
    TT_VIEW_MENU_BUTTON_CLICK: "tt_view_menu_button_click",
    TT_ALL_REVIEWS_BUTTON_CLICK: "tt_all_reviews_button_click",
    TT_DOWNLOAD_APP_BUTTON_CLICK: "tt_download_app_button_click",
    TT_SOCIAL_PROOF_POPUP_SHOWN: "tt_social_proof_popup_shown",
    TT_START_QUIZ_CLICK: "tt_start_quiz_click",
    TT_ALSO_FEATURED_IN_CLICK: "tt_also_featured_in_click",
    TT_POPUP_SHOWED: "tt_popup_showed",
    TT_POPUP_CLOSED: "tt_popup_closed",

    TT_PLACE_VIEWED: "tt_place_viewed",
    TT_ITEM_TAPPED: "tt_item_tapped",
    TT_PAGE_SCROLLED: "tt_page_scrolled",

    TT_MODAL_SHOWN: "tt_modal_shown",
    TT_MODAL_CTA_CLICKED: "tt_modal_cta_clicked",
    TT_MODAL_DISMISSED: "tt_modal_dismissed",

    TT_SLIDER_SHOWN: "tt_slider_shown",
    TT_SLIDER_DISMISSED: "tt_slider_dismissed",
    TT_SLIDER_ANSWER_SELECTED: "tt_slider_answerSelected",

    TT_QUIZ_ACTION: "tt_quiz_action",
    TT_QUIZ_PAGE_VIEWED: "tt_quiz_page_viewed",
    TT_QUIZ_FORM_SUBMIT: "tt_quiz_form_submit",
    TT_QUIZ_PAYMENT_REDIRECT: "tt_quiz_payment_redirect",
    TT_QUIZ_BRANCH_REDIRECT: "tt_quiz_branch_redirect",
    TT_QUIZ_CHECKOUT_API_SUCCESS: "tt_quiz_checkout_api_success",
    TT_QUIZ_CHECKOUT_API_ERROR: "tt_quiz_checkout_api_error",

    INDIRECT_ADS_QUIZ_START: "indirect_ads_quiz_start",
    INDIRECT_ADS_QUIZ_PAGE_VIEWED: "indirect_ads_quiz_page_viewed",
    INDIRECT_ADS_QUIZ_ACTION: "indirect_ads_quiz_action",

    INDIRECT_ADS_QUIZ_FORM_SUBMIT: "indirect_ads_quiz_form_submit",

    WEB_2_APP_CHECKOUT_SUCCESS_SCREEN_VIEWED: "web2app_checkoutSuccessScreen_viewed",
    WEB_2_APP_END_QUIZ_DOWNLOAD_CLICKED: "web2app_end_quiz_download_clicked",
};

export const MixpanelProps = {
    STEP_NAME: "step_name",
    STEP_ID: "step_id",
    STEP_RANK_ON_PAGE: "step_rank_on_page",
    CREATED_BY_MAP_MANAGER: "created_by_map_manager",
    TEST_VERSION: "test_version",
    IS_PAID: "is_paid",
    PLATFORM: "platform",
    IS_APP_INSTALLED: "is_app_installed",
    USER_SOURCE: "user_source",
    USER_REGION: "user_region",
    URL: "url",
    MAP_ID: "map_id",
    MAP_NAME: "map_name",
    TT_NAME: "tt_name",
    PAGE_AREA: "page_area",
    BUTTON_DESTINATION: "button_destination",
    GLUTEN_FREE_COUNT_IN_AREA: "gluten_free_count_in_area",
    GLUTEN_FREE_COUNT_IN_AREA_SHOWN: "gluten_free_count_in_area_shown",
    SOCIAL_PROOF_TEST_BUTTON_ANIMATION: "button_animation",
    SOCIAL_PROOF_TEST_BUTTON_SIZE: "button_size",
    SOCIAL_PROOF_TEST_BUTTON_CTA: "button_cta",
    SOCIAL_PROOF_TEST_SOCIAL_PROOF_POPUP_VERSION: "social_proof_popup_version",
    SOCIAL_PROOF_TEST_SOCIAL_PROOF_POPUP_DELAY: "social_proof_popup_delay",
    SOCIAL_PROOF_TEST_BUTTON_DESTINATION: "button_destination",
    SOCIAL_PROOF_TEST_VARIATION: "social_proof_test_variation",
    TAG: "tag",
    CITY: "city",
    COUNTRY: "country",
    REGION: "region",
    LIST_SIZE: "list_size",
    PLACE_IN_LIST: "place_in_list",
    PLACEMENT: "placement",
    BUTTON_CTA: "button_cta",
    TAPPED_ITEM: "tapped_item",
    VERSION: "version",
    SOCIAL_PROOF: "social_proof",
    TRIGGER: "trigger",
    ANSWER_POSITION: "answer_position",
    ANSWER_TEXT: "answer_text",
    QUESTION_TEXT: "question_text",
    USER_AGENT: "user_agent",
    WEB_2_APP_FLOW: "web2app_flow",
    DESIGN_VERSION: "design_version",
    PROMOTION_CODE: "promotion_code",
    SEARCH_PARAMS_LINK: "search_params_link",
    AUTO_LOGIN_BRANCH_LINK: "auto_login_branch_link",
    USER_EMAIL: "user_email",
    STRIPE_ELEMENT_FLOW: "stripe_element_flow",
};

export const MixpanelValues = {
    Placement: {
        TOP_OF_FOOTER: "top_of_footer",
        BOTTOM_OF_FOOTER: "bottom_of_footer",
        NAME_AND_ADDRESS: "replace_name_and_address",
        OVER_MAP: "over_map",
    },
    ButtonCta: {
        START_FREE_TRIAL: "Start free trial",
        JOIN_COMMUNITY: "Join the community",
        UNLOCK: "Unlock",
        GET_THE_APP: "Get the app",
    },
    ItemTapped: {
        AWARD_EMBLEM: "Award Emblem",
        ALSO_FEATURED_IN: "Also Featured In",
        GLUTEN_FREE_REC_COUNT: "Gluten Free Rec Count",
        NAME: "Name",
        BLURB: "Blurb",
        IMAGE: "Image",
        ADDRESS: "Address",
        SAFETY_RATING: "Safety Rating",
        LEARN_MORE: "Learn More",
        REVIEW_TEXT: "Review Text",
        TAGS: "Tags",
        APP_STORE: "App Store",
        PLAY_STORE: "Play Store",
        MAIN_CTA: "Main CTA",
        FOOTER_TOP_BUTTON: "Footer Top Button",
        FOOTER_BOTTOM_BUTTON: "Footer Bottom Button",
        LINK_TO_GOOGLE_REVIEW: "Link to Google Review",
        ATLY_LOGO: "Atly Logo",
        GLUTEN_FREE_COMMUNITY: "Gluten Free Community",
        VIEW_MENU: "View Menu",
    }
};
